export default __webpack_public_path__ + "static/media/pqi_img.f40c375a.png";